import { render, staticRenderFns } from "./BeneficiaryList.vue?vue&type=template&id=c56a58ec&scoped=true"
import script from "./BeneficiaryList.vue?vue&type=script&lang=js"
export * from "./BeneficiaryList.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryList.vue?vue&type=style&index=0&id=c56a58ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56a58ec",
  null
  
)

export default component.exports